/**
 * Sibling device selector (Burga-style)
 * ------------------------------------------------------------------
 * Given the current product's design name, finds the sibling products
 * (same design, different device type) via Shopify storefront predictive
 * search and renders a switch row: [ Cover iPhone | AirPods | AirPods Max ].
 *
 * Only LIVE (published) products appear in predictive search, so links are
 * never broken. Matching is by exact title ("{designName} {typeSuffix}"),
 * so it never over-matches a different design.
 */
(function () {
  // Device types in display order. `suffix` = the product_type / title suffix.
  var DEVICE_TYPES = [
    // `it` = prefisso del titolo italiano ("Cover iPhone Tough <design>"), vedi CLAUDE.md "Traduzioni italiane"
    { suffix: 'Tough iPhone Case', it: 'Cover iPhone Tough', label: 'Cover iPhone', icon: '📱' } // 📱
  ];

  function shopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root; // e.g. "/" or "/en/"
    }
    return '/';
  }

  function isType(dt, type) {
    return norm(dt.suffix) === norm(type) || norm(dt.it) === norm(type);
  }

  function norm(s) {
    return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  class SiblingDeviceSelector extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.designName = this.dataset.designName || '';
      this.currentType = this.dataset.currentType || '';
      this.currentHandle = this.dataset.currentHandle || '';
      this.row = this.querySelector('.cls-devsel__row');
      if (!this.designName || !this.row) return;
      this.load();
    }

    async load() {
      this.classList.add('is-loading');
      var found = {};
      try {
        var url = shopRoot().replace(/\/$/, '') +
          '/search/suggest.json?q=' + encodeURIComponent(this.designName) +
          '&resources[type]=product&resources[limit]=10' +
          '&resources[options][unavailable_products]=last';
        var res = await fetch(url, { headers: { 'Accept': 'application/json' } });
        if (res.ok) {
          var data = await res.json();
          var products = (((data || {}).resources || {}).results || {}).products || [];
          // Match each device type by EXACT expected title.
          DEVICE_TYPES.forEach(function (dt) {
            var expected = [norm(this.designName + ' ' + dt.suffix), norm(dt.it + ' ' + this.designName)];
            for (var i = 0; i < products.length; i++) {
              if (expected.indexOf(norm(products[i].title)) !== -1) {
                found[dt.suffix] = products[i];
                break;
              }
            }
          }, this);
        }
      } catch (e) {
        /* progressive enhancement — fall back to server-rendered current button */
      }

      this.render(found);
      this.classList.remove('is-loading');
    }

    render(found) {
      // If we found nothing for siblings, keep the server-rendered current button as-is.
      var anySibling = DEVICE_TYPES.some(function (dt) {
        return found[dt.suffix] && !isType(dt, this.currentType);
      }, this);
      if (!anySibling && !Object.keys(found).length) return;

      var self = this;
      var html = '';
      DEVICE_TYPES.forEach(function (dt) {
        var isCurrent = isType(dt, self.currentType);
        var prod = found[dt.suffix];
        if (!isCurrent && !prod) return; // sibling not published / doesn't exist → skip

        var href = isCurrent
          ? (window.location.pathname)
          : (prod && prod.url ? prod.url : '#');
        var cls = 'cls-devsel__btn' + (isCurrent ? ' is-active' : '');
        var aria = isCurrent ? ' aria-current="true"' : '';
        html += '<a class="' + cls + '"' + aria + ' href="' + href + '">' +
          '<span class="cls-devsel__btn-icon" aria-hidden="true">' + dt.icon + '</span>' +
          '<span class="cls-devsel__btn-name">' + dt.label + '</span>' +
          '</a>';
      });

      if (html) this.row.innerHTML = html;
    }
  }

  if (!customElements.get('sibling-device-selector')) {
    customElements.define('sibling-device-selector', SiblingDeviceSelector);
  }
})();
